module.exports = __webpack_public_path__ + "static/media/jenkins-j-icon.91089d1b.webp";